import { Modal } from "antd";
import React from "react";
import styles from "./index.module.scss";
import { Button } from "app/(new-pages)/components/Button/pc/index.pc";
import { setCookie } from "helpers/cookies";
import SingpassButton from "../SingpassButton";

const VerifyIdentity = ({ open = false, onClose = () => {}, dic, handleSingpassClick }) => {
  const handleClose = () => {
    const time = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
    setCookie("singpassDolater", "1", time);
    onClose();
  };

  return (
    <Modal
      open={open}
      footer={null}
      width={420}
      onCancel={handleClose}
      maskClosable={false}
      centered
      title={dic?.verifyYourIdentity}
      wrapClassName={styles.wrapClassNameModal}
    >
      <p className={styles.tips}>{dic?.unlockMoreJobOpportunities}</p>
      <p className={styles.info}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='19'
          viewBox='0 0 20 19'
          fill='none'
        >
          <rect
            x='0.666504'
            y='0.160156'
            width='18.6667'
            height='18.6667'
            rx='2.66667'
            fill='#3CEAF6'
          />
          <path
            d='M5.95654 6.60866V5.33594H13.9565V6.60866H5.95654ZM9.32018 13.5178V9.20867L7.66563 10.8632L6.77472 9.9723L9.95654 6.79048L13.1384 9.9723L12.2475 10.8632L10.5929 9.20867V13.5178H9.32018Z'
            fill='#1F1F1F'
          />
        </svg>
        {dic?.maximizeExposure}
      </p>
      <p className={styles.tips}>{dic?.verifiedCandidatesArePrioritized}</p>
      <p className={styles.info}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='19'
          viewBox='0 0 20 19'
          fill='none'
        >
          <rect
            x='0.666504'
            y='0.160156'
            width='18.6667'
            height='18.6667'
            rx='2.66667'
            fill='#3CEAF6'
          />
          <path
            d='M9.99976 4.94141C12.0941 4.94141 13.8752 6.3199 15.3738 8.7373L15.5496 9.02246L15.5691 9.05371L15.5496 9.08496L15.3738 9.36914C13.8752 11.7866 12.0941 13.166 9.99976 13.166C7.90539 13.166 6.12432 11.7866 4.62573 9.36914L4.44995 9.08496L4.43042 9.05371L4.44995 9.02246L4.62573 8.7373C6.12432 6.3199 7.9054 4.94141 9.99976 4.94141ZM9.99976 6.13965C8.58319 6.13965 7.19051 7.01333 5.84741 9.05371C7.19044 11.0938 8.58328 11.9668 9.99976 11.9668C11.4161 11.9668 12.8082 11.0935 14.1511 9.05371C12.8081 7.01365 11.4162 6.13965 9.99976 6.13965ZM9.99976 7.10254C11.077 7.10254 11.95 7.97645 11.95 9.05371C11.9498 10.1308 11.0769 11.0039 9.99976 11.0039C8.92258 11.0039 8.04971 10.1308 8.04956 9.05371C8.04956 7.97645 8.92249 7.10254 9.99976 7.10254ZM9.99976 8.30176C9.58459 8.30176 9.2478 8.63854 9.2478 9.05371C9.24795 9.46875 9.58468 9.80469 9.99976 9.80469C10.4148 9.80469 10.7516 9.46875 10.7517 9.05371C10.7517 8.63854 10.4149 8.30176 9.99976 8.30176Z'
            fill='black'
            stroke='black'
            strokeWidth='0.117918'
          />
        </svg>
        {dic?.browseExclusiveJobs}
      </p>
      <p className={styles.tips}>{dic?.verificationUnlocksAdditionalJob}</p>
      <div className={styles.footer}>
        <SingpassButton onClose={handleSingpassClick || onClose} />
        <Button variant='whiteBoxShadowBtn' btnSize='size40' onClick={handleClose}>
          {dic?.doItLater}
        </Button>
      </div>
    </Modal>
  );
};

export default VerifyIdentity;
